import React from 'react';

export const userDeleteConfirmOptions = {
  title: 'Are you sure you want to delete this User?',
  body:
    'Deleting a user is a permanent action. Are you sure you want to continue?',
  actionName: 'Delete User',
  actionType: 'danger',
};

export const FormLayout = ({ fields, error, buttons, meta }) => (
  <form>
    <div className="row">
      <div className="col-6">{fields.get('username')}</div>
      <div className="col-6">{fields.get('email')}</div>
      <div className="col-12">{fields.get('displayName')}</div>
      <div className="col-12">{fields.get('enabled')}</div>
      <div className="col-12">{fields.get('spaceAdmin')}</div>
      <div className="col-12">
        {meta.getIn(['password', 'visible']) ? (
          <fieldset>
            <legend className="visually-hidden">Change password</legend>

            {fields.get('password')}
            {fields.get('passwordConfirmation')}
            {fields.get('changePassword')}
          </fieldset>
        ) : (
          <div className="form-group">{fields.get('changePassword')}</div>
        )}
      </div>
      <div className="col-12">{fields.get('allowedIps')}</div>
    </div>
    {error}
    <div className="form-buttons">{buttons}</div>
  </form>
);
